import downloadFileFromDatalake from '@/utils/downloadFileFromDatalake';
import { triggerBlobDownload } from '@/utils/triggerBlobDownload';

const downloadFile = async (fileId: string, fileName: string, maxRetries = 3) => {
  let lastError: unknown;

  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    try {
      // eslint-disable-next-line no-await-in-loop
      const fileResponse = await downloadFileFromDatalake(fileId);
      triggerBlobDownload(fileResponse.data, fileName);
      return;
    } catch (error) {
      lastError = error;
      console.error('Error downloading file:', error);
      if (attempt < maxRetries)
        // eslint-disable-next-line no-await-in-loop
        await new Promise<void>(resolve => {
          setTimeout(resolve, 500);
        });
    }
  }

  throw lastError instanceof Error ? lastError : new Error('Error downloading file');
};

export default downloadFile;
